import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const DEFAULTS = {
    hide_out_of_stock: true,
    low_stock_threshold: 2,
    show_japanese_name: true,
    show_selling_points: true,
};

const SettingsContext = createContext({
    settings: DEFAULTS,
    refresh: () => {},
    save: () => {},
    loaded: false,
});

export const useSettings = () => useContext(SettingsContext);

export function SettingsProvider({ children }) {
    const { user } = useAuth();
    const [settings, setSettings] = useState(DEFAULTS);
    const [loaded, setLoaded] = useState(false);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/settings");
            setSettings({ ...DEFAULTS, ...data });
        } catch {
            setSettings(DEFAULTS);
        } finally {
            setLoaded(true);
        }
    }, []);

    useEffect(() => {
        if (user && user.id && user.role !== "finance" && user.role !== "meta_ads_viewer") refresh();
    }, [user, refresh]);

    const save = useCallback(
        async (patch) => {
            const { data } = await api.put("/settings", patch);
            setSettings({ ...DEFAULTS, ...data });
            return data;
        },
        [],
    );

    return (
        <SettingsContext.Provider value={{ settings, refresh, save, loaded }}>
            {children}
        </SettingsContext.Provider>
    );
}
